export default "__VITE_ASSET__ce687b1f__"